import './CategoryTiles.css';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get } from '../../utils';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { CategoryTilesCard } from './components/CategoryTilesCard';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
const CategoryTiles = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields || !fields.data || !fields.data.datasource) {
    console.info('CategoryTiles component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CategoryTiles component is empty: please provide data source]");
    }
    return null;
  }
  const hasTitle = Boolean(get(fields, 'data.datasource.title.jss.value'));
  const componentId = get(fields, 'data.datasource.id');
  const title = get(fields, 'data.datasource.title.jss');
  const hasShortDescription = Boolean(get(fields, 'data.datasource.shortDescription.jss.value'));
  const shortDescription = get(fields, 'data.datasource.shortDescription.jss');
  const childrenItems = get(fields, 'data.datasource.carousel.values', []);
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const analyticsCarouselButtonHandler = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['RightOrLelftAnalytics'], params), text);
  };
  const renderItems = () => {
    return childrenItems.map((item, index) => {
      return /*#__PURE__*/React.createElement("a", {
        "aria-label": "Category Tiles Card",
        "aria-labelledby": "Category Tiles Card",
        href: item.navigationButton.jss.value.href,
        key: item.id
      }, /*#__PURE__*/React.createElement(CategoryTilesCard, {
        componentId: componentId,
        item: item,
        eventsAnalytics: eventsAnalytics,
        params: params,
        index: index
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "categoryTilesWrapper"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderProgressBar
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "textWithButtons"
    }, hasTitle && /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title",
      field: title
    }), /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, renderPreviousButton(() => analyticsCarouselButtonHandler("left")), renderNextButton(() => analyticsCarouselButtonHandler("right")))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 5
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 901
          },
          items: 4
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 701
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 700,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }), /*#__PURE__*/React.createElement("div", {
      className: "progressBar"
    }, renderProgressBar())));
  }))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "cx9sz1p";
const rtlStyles = "r13lez2t";
const ltrStyles = "lzl2ejj";
export default CategoryTiles;